import React from 'react'

export default function EyeDiseaseSingle() {
  return (
    <div>EyeDiseaseSingle</div>
  )
}
